let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eqcFa")).then(() => parcelRequire('a7NHJ'));